import naja from "naja";
import TinySliders from "./TinySlider";

export default class BookingHeaderForm {
    static init(): void {
        const form = document.querySelector('#booking-header-form') as HTMLFormElement;
        const ajaxSpinner = document.querySelector('.ajax-spinner') as HTMLElement;
        if (!form) return;

        const submit = form.querySelector('#bookingSubmit') as HTMLButtonElement;
        const formName = form.getAttribute('data-name') as string | null;
        const messageElement = document.getElementById('booking-header__message') as HTMLElement;

        submit.addEventListener('click', (e) => {
            e.preventDefault();

            // const formData = new FormData();
            const bookingDateFrom = form.querySelector('#bookingDateFrom') as HTMLInputElement;
            const bookingDateTo = form.querySelector('#bookingDateTo') as HTMLInputElement;
            const people = form.querySelector('#booking-header__people') as HTMLInputElement;

            if (bookingDateFrom.value === '' || bookingDateTo.value === '') {
                messageElement.innerHTML = 'Prosím vyplňte datum pobytu.';
                return;
            } else {
                messageElement.innerHTML = '';
            }

            const url = form.getAttribute('data-action') as string;
            if (!url) return;

            ajaxSpinner?.classList.add('ajax-spinner--show');

            const formData = new FormData();
            formData.append('bookingDateFrom', bookingDateFrom.value);
            formData.append('bookingDateTo', bookingDateTo.value);
            formData.append('people', people.value);

            naja.makeRequest('POST', url, formData, {
                history: false,
            }).then((response) => {
                if (formName === 'booking-header-package') {
                    const packageForm = document.querySelector('#package-form') as HTMLElement;

                    if (response.available) {
                        const dateFromElement = packageForm.querySelector('#booking-reservation__summary-date-from') as HTMLInputElement | null;
                        const dateToElement = packageForm.querySelector('#booking-reservation__summary-date-to') as HTMLInputElement | null;
                        if (dateFromElement && dateToElement) {
                            dateFromElement.innerHTML = response.dateFrom;
                            dateToElement.innerHTML = response.dateTo;
                        }

                        packageForm.classList.remove('d-none');
                        // scroll to package form
                        const packageFormOffset = packageForm.offsetTop;
                        window.scrollTo({
                            top: packageFormOffset,
                            behavior: 'smooth'
                        });
                    } else {
                        packageForm.classList.add('d-none');
                    }

                    const messageElement = document.getElementById('booking-header__message') as HTMLElement;
                    if (response.message) {
                        messageElement.innerHTML = response.message;
                    } else {
                        messageElement.innerHTML = '';
                    }
                } else {
                    const filter = document.querySelector('.booking-filter');
                    const filterItems = filter?.querySelectorAll('.booking-filter__item') as NodeListOf<HTMLElement>;
                    filterItems?.forEach(item => {
                        const type = item.getAttribute('data-room-type');
                        if (type === 'all') {
                            item.classList.add('booking-filter__item--active');
                        } else {
                            item.classList.remove('booking-filter__item--active');
                        }
                    });
                }

                ajaxSpinner?.classList.remove('ajax-spinner--show');
                TinySliders.bookingImageSlider();
            })
        });

    }
}
